import {
	Resources,
	type useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MONTHS_IN_YEAR } from "web_myplann/Shared/constants";

type TranslateFunction = ReturnType<typeof useResource>["t"];

const EarlierResources = Resources.Goals.Detail.ExtraContribution.Earlier;

export const formatMonthsSaved = (
	monthsSaved: number,
	t: TranslateFunction,
): string => {
	const years = Math.floor(monthsSaved / MONTHS_IN_YEAR);
	const months = monthsSaved % MONTHS_IN_YEAR;

	const parts = [
		years > 0 ? t(EarlierResources.years, { count: years }) : "",
		months > 0 ? t(EarlierResources.months, { count: months }) : "",
	].filter(Boolean);

	return parts.join(` ${t(EarlierResources.and)} `) || t(EarlierResources.none);
};
